module.exports = __webpack_public_path__ + "static/assets/7533b57c54828b5305708a4ac04a7c1c.png";